/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../Constants';
import { Document } from '../models/Document';
import { Extension } from '../models/Extension';
import { NodePath } from '../models/NodePath';
import { ValidationProblem } from '../models/ValidationProblem';
import { Contact } from '../models/common/Contact';
import { ExternalDocumentation } from '../models/common/ExternalDocumentation';
import { IDefinition } from '../models/common/IDefinition';
import { Info } from '../models/common/Info';
import { License } from '../models/common/License';
import { Operation } from '../models/common/Operation';
import { Parameter } from '../models/common/Parameter';
import { Schema } from '../models/common/Schema';
import { SecurityRequirement } from '../models/common/SecurityRequirement';
import { SecurityScheme } from '../models/common/SecurityScheme';
import { Tag } from '../models/common/Tag';
import { IVisitor } from './IVisitor';
import { Node } from '../models/Node';

/**
 * Constructor.
 * @class
 * @author eric.wittmann@gmail.com
 */
export class NodePathVisitor implements IVisitor {
    path : NodePath = new NodePath();

    public constructor() {
    }

    /**
     * Gets the path that was created.
     * @return {NodePath}
     */
    public getPath() : NodePath {
        return this.path;
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitValidationProblem(io.apicurio.datamodels.core.models.ValidationProblem)
     * @param {ValidationProblem} problem
     */
    public visitValidationProblem(problem : ValidationProblem) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExtension(io.apicurio.datamodels.core.models.Extension)
     * @param {Extension} node
     */
    public visitExtension(node : Extension) {
        this.path.prependSegment(node.name, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitInfo(io.apicurio.datamodels.core.models.common.Info)
     * @param {Info} node
     */
    public visitInfo(node : Info) {
        this.path.prependSegment(Constants.PROP_INFO, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitContact(io.apicurio.datamodels.core.models.common.Contact)
     * @param {Contact} node
     */
    public visitContact(node : Contact) {
        this.path.prependSegment(Constants.PROP_CONTACT, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        this.path.prependSegment(Constants.PROP_LICENSE, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitTag(io.apicurio.datamodels.core.models.common.Tag)
     * @param {Tag} node
     */
    public visitTag(node : Tag) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_TAGS);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_TAGS, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_SECURITY);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_SECURITY, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} node
     */
    public visitExternalDocumentation(node : ExternalDocumentation) {
        this.path.prependSegment(Constants.PROP_EXTERNAL_DOCS, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
        this.path.prependSegment(Constants.PROP_SCHEMA, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_PARAMETERS);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_PARAMETERS, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.path.prependSegment(node.getType(), false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.NodePathVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.path.prependSegment(node.getSchemeName(), true);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.path.prependSegment(node.getName(), true);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.path.prependSegment(node.getName(), true);
    }
}
NodePathVisitor["__class"] = "io.apicurio.datamodels.core.visitors.NodePathVisitor";
NodePathVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor"];




